import { UserRow } from 'components/tables/data/user/types';
import P3Regular from 'components/typography/P3Regular';

/**
 * Column for the user id.
 */
export default function UserIdColumn({ data: { userId } }: { data: UserRow }) {
  return <P3Regular color="gray.8">{userId}</P3Regular>;
}
